import React from "react";
import styles from "./WagersLabel.module.scss";

export type WagersType = "bonus" | "real";

type Props = {
  wagers: WagersType[];
};

const wagersClassMap: Record<WagersType, string> = {
  bonus: styles["wagers-label--bonus"],
  real: styles["wagers-label--real"],
};

export const WagersLabel: React.FC<Props> = ({ wagers }) => {
  if (!Array.isArray(wagers) || wagers.length === 0) {
    return <>-</>;
  }
  return (
    <div className={styles.wrapper}>
      {wagers.map((wager, index) => (
        <div
          key={index}
          className={`${styles["wagers-label"]} ${wagersClassMap[wager]}`}
        >
          {wager}
        </div>
      ))}
    </div>
  );
};
